import React from 'react';
import { SortableHandle } from 'react-sortable-hoc';

// Components
import Icon from '@src/components/Icon';

// Consts
import {
  NODE_BOT_SAYS_FILTER_TOOLTIP,
  NODE_BOT_SAYS_EDIT_ENTITY_TOOLTIP,
  NODE_BOT_SAYS_ENTITY_DEPRECATED_TOOLTIP,
  NODE_BOT_SAYS_REMOVE_ENTITY_TOOLTIP,
  NODE_BOT_SAYS_REORDER_ENTITY_TOOLTIP,
  NODE_BOT_SAYS_SECTION_COLLAPSE_TOOLTIP,
  NODE_BOT_SAYS_SECTION_EXPAND_TOOLTIP,
} from '@src/constants/Tooltips';

// Local
import Checkbox from '../Checkbox';

export default ({
  onToggle,
  toggled,
  DOMRef,
  onHoldWithBotToggle,
  value,
  onDelete,
  onEdit,
  onMandatoryWords,
  noDrag,
}) => {
  const toggledClassName = toggled ? 'toggled' : '';
  return (
    <div className="bot-says-card-header" ref={DOMRef} onClick={onToggle}>
      <div className="bot-says-card-header-row">
        {!noDrag ? [<DragHandle key="2" />] : null}
        <div className="bot-says-card-header-row-cta-icon no-margin">
          <Checkbox active={value.mandatory} onClick={onHoldWithBotToggle} />
        </div>
        {value.deprecated && (
          <Icon
            iconType="deprecated"
            tooltip={NODE_BOT_SAYS_ENTITY_DEPRECATED_TOOLTIP.text}
            className="bot-says-card-header-row-cta-icon deprecated"
          />
        )}
        <div
          className={`bot-says-card-header-row-title ${
            value.mandatory ? 'mandatory' : ''
          } ${value.deprecated ? 'deprecated' : ''}`}
        >
          {value.title}
        </div>
        <div className="bot-says-card-header-row-cta">
          <Icon
            onClick={onMandatoryWords}
            iconType={
              (value.mandatoryWords || []).length > 0
                ? 'filter_filled'
                : 'filter'
            }
            tooltip={NODE_BOT_SAYS_FILTER_TOOLTIP.text}
            className="bot-says-card-header-row-cta-icon"
          />
          <Icon
            onClick={(e) => onEdit(value.title, value.id, e)}
            iconType="edit"
            tooltip={NODE_BOT_SAYS_EDIT_ENTITY_TOOLTIP.text}
            className="bot-says-card-header-row-cta-icon"
          />
          <Icon
            onClick={onDelete}
            tooltip={NODE_BOT_SAYS_REMOVE_ENTITY_TOOLTIP.text}
            iconType="trash"
            className="bot-says-card-header-row-cta-icon"
          />
          <Icon
            onClick={onToggle}
            iconType="angle-down"
            className={`bot-says-card-header-row-cta-icon ${toggledClassName}`}
            tooltip={
              toggled
                ? NODE_BOT_SAYS_SECTION_COLLAPSE_TOOLTIP.text
                : NODE_BOT_SAYS_SECTION_EXPAND_TOOLTIP.text
            }
          />
        </div>
      </div>
    </div>
  );
};

const DragHandle = SortableHandle(() => (
  <Icon
    iconType="reorder"
    className="bot-says-card-header-row-icon"
    tooltip={NODE_BOT_SAYS_REORDER_ENTITY_TOOLTIP.text}
  />
));
